import React from 'react';
import { IBaseComponent } from '~/sharedInterfaces/IBaseComponent';
import LoanAmount from '../components/LoanAmount/LoanAmount';
import OrgNumber from '../components/OrgNumber/OrgNumber';
import Email from '../components/Email/Email';
import TermsAgreement from '../components/TermsAgreement/TermsAgreement';
import PaginationButton from '../components/PaginationButton/PaginationButton';
import PhoneNumber from '../components/PhoneNumber/PhoneNumber';
import LoanTerm from '../components/LoanTerm/LoanTerm';
import IFormComponents from '../sharedInterfaces/IFormComponents';
import ComponentError from '../components/ComponentError/ComponentError';
import LoanPurpose from '~/components/LoanPurpose/LoanPurpose';
// import BankIntegration from '~/components/BankIntegration/BankIntegration';
import DocumentUpload from '~/components/DocumentUpload/DocumentUpload';
import PersonalNumber from '~/components/PersonalNumber/PersonalNumber';
import Turnover from '~/components/Turnover/Turnover';
import Website from '~/components/Website/Website';
import LoanCalculator from '~/components/LoanCalculator/LoanCalculator';
import Text from '~/components/Base/Text/Text';
import HomeAddress from '~/components/HomeAddress/HomeAddress';
import ThankYouMessage from '~/components/ThankYouMessage/ThankYouMessage';
import Header from '~/components/Base/Header/Header';
import Link from '~/components/Link/Link';
import RlcRedirect from '~/components/RlcRedirect/RlcRedirect.tsx';
import BankIntegration from '~/components/BankIntegration/BankIntegration';
import CardPurpose from '~/components/CardPurpose/CardPurpose';

const FormComponents: IFormComponents = {
  loanAmount: (props) => <LoanAmount {...props} />,
  loanTerm: (props) => <LoanTerm {...props} />,
  loanPurpose: (props) => <LoanPurpose {...props} />,
  cardPurpose: (props) => <CardPurpose {...props} />,
  loanCalculator: (props) => <LoanCalculator {...props} />,
  orgNumber: (props) => <OrgNumber {...props} />,
  emailAddress: (props) => <Email {...props} />,
  phoneNumber: (props) => <PhoneNumber {...props} />,
  termsAgreement: (props) => <TermsAgreement {...props} />,
  bankIntegration: (props) => <BankIntegration {...props} />,
  documentUpload: (props) => <DocumentUpload {...props} />,
  personalNumber: (props) => <PersonalNumber {...props} />,
  turnover: (props) => <Turnover {...props} />,
  website: (props) => <Website {...props} />,
  text: (props) => <Text {...props} />,
  thankYouMessage: (props) => <ThankYouMessage {...props} />,
  rlcRedirect: (props) => <RlcRedirect {...props} />,
  next: (props) => <PaginationButton {...props} />,
  previous: (props) => <PaginationButton {...props} />,
  homeAddress: (props) => <HomeAddress {...props} />,
  header: (props) => <Header {...props} />,
  link: (props) => <Link {...props} />,
};

const GetComponent: React.FC<IBaseComponent> = (props) => {
  return FormComponents[props.componentName] ? (
    <div className="qred-wrapper">{FormComponents[props.componentName](props)}</div>
  ) : (
    <ComponentError error={`Component with name ${props.componentName} couldn't be found.`} />
  );
};

export default GetComponent;
